/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FiAlertTriangle, FiBarChart2, FiPackage, FiPlus } from 'react-icons/fi'
import { NavBar } from '../../components/NavBar'
import useSWR from 'swr'
import { api } from '../../api/api'
import { mascaraMoeda, maskCurrency } from '../../utils/utils'
import { useContext, useEffect, useState } from 'react'
import { Toast } from '../../utils/Toast'
import { GlobalContext } from '../../context/GlobalContext'
import { ReportProdutFiscalOrNotFiscal } from '../../components/report/productsFiscalOrNotFiscal'
import '../admin.css'

const STATE_DEFAULT = {
  name: '',
  pricing: '',
  stock: '',
  type: 'UN'
}

export function StockPage() {
  const { isAccess } = useContext(GlobalContext)

  const { data, isLoading, mutate } = useSWR('list-stocks', async () => {
    const value = await api.get('/stocks')
    return value?.data
  })

  const [state, setState] = useState(STATE_DEFAULT)
  const [reportRefFiscalValue, setReportRefFiscalValue] = useState(null)

  async function onChange(id, key, value) {
    if (!isAccess('estoque', 'update')) {
      Toast.warning('Você não tem acesso para atualizar um estoque')
      return
    }

    const oldValue = [...data]
    try {
      const newData = data.map(e => {
        if (e.id === id) {
          return { ...e, [key]: value }
        }
        return e
      })

      mutate(newData, { revalidate: false })

      if (value !== null && value !== undefined && value !== "") {
        await api.put('/stocks/' + id, {
          [key]: value
        })
      }

    } catch (error) {
      mutate(oldValue, { revalidate: false })
    }
  }

  async function created(body) {
    const confirmation = await Toast.confirm("Caso movimentar este estoque com está unidade, futuramente não poderá ser alterada", "Cancelar", "Confirmar")

    if (!confirmation) {
      return
    }

    const response = await api.post('/stocks', body)
    Toast.success()

    const newData = [...data, {
      id: response.data.id,
      name: body.name,
      pricing: body.pricing,
      stock: body.stock,
      type: body.type || 'UN'
    }]

    mutate(newData, { revalidate: false })
    setState(STATE_DEFAULT)
  }

  // useEffect(() => {
  //   if (reportRefFiscalValue !== null) {
  //     setTimeout(() => {
       
  //       setReportRefFiscalValue(null)
  //     }, 300);
  //   }
  // }, [reportRefFiscalValue])

  return (
    <>
      <ReportProdutFiscalOrNotFiscal refFiscal={reportRefFiscalValue} set={setReportRefFiscalValue} />
      <NavBar>
        <main className="admin-page stock-page">
          <header className="admin-page-header">
            <div><h1>Estoque</h1><p>Gerencie insumos, quantidades e custos dos produtos</p></div>
            <div className="admin-header-actions dropdown">
              <button className="admin-secondary-button dropdown-toggle" type="button" data-bs-toggle="dropdown"><FiBarChart2 /><span>Relatórios</span></button>
              <ul className="dropdown-menu">
                <li><button className="dropdown-item" onClick={() => setReportRefFiscalValue(true)}>Com informação fiscal</button></li>
                <li><button className="dropdown-item" onClick={() => setReportRefFiscalValue(false)}>Sem informação fiscal</button></li>
              </ul>
            </div>
          </header>

            {isLoading && (
              <div className="admin-loading"><div className="spinner-border" role="status"><span className="visually-hidden">Carregando...</span></div></div>
            )}
            {!isLoading && (
              <>
                {isAccess('estoque', 'create') && (
                  <section className="admin-surface">
                    <div className="admin-surface-header"><div><h2>Novo item de estoque</h2><p>Cadastre um insumo antes de vinculá-lo à ficha técnica</p></div></div>
                    <div className="admin-form-grid">
                      <label><span>Nome</span><input type="text" value={state.name} onChange={(e) => setState({ ...state, name: e.target.value })} /></label>
                      <label><span>Preço</span><input type="text" value={maskCurrency(state.pricing)} onChange={(e) => setState({ ...state, pricing: mascaraMoeda(e.target.value) })} /></label>
                      <label><span>Quantidade</span><input type="number" value={state.stock} onChange={(e) => setState({ ...state, stock: e.target.value })} /></label>
                      <label><span>Unidade</span><select value={state.type} onChange={(e) => setState({ ...state, type: e.target.value })}><option value="UN">Unidade</option><option value="LT">Litro</option><option value="KG">Quilograma</option></select></label>
                      <button className="admin-primary-button" onClick={() => created(state)}><FiPlus /> Adicionar</button>
                    </div>
                  </section>
                )}

                <section className="admin-surface">
                  <div className="admin-surface-header"><div><h2>Itens cadastrados</h2><p>{data?.length || 0} itens no estoque</p></div><FiPackage size={19} /></div>
                  <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Status</th><th>Nome</th><th>Preço unitário</th><th>Quantidade</th><th>Unidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map(value => {
                      return (
                        <tr key={value.id}>
                          <td data-label="Status">{value.stock <= value.stockAlert ? <span className="admin-status inactive"><FiAlertTriangle /> Estoque baixo</span> : <span className="admin-status active">Normal</span>}</td>
                          <td data-label="Nome"><input type="text" value={value.name} onChange={(e) => onChange(value.id, 'name', e.target.value)} /></td>
                          <td data-label="Preço">
                            <input
                              type="text"
                              value={maskCurrency(value?.pricing ?? 0)}
                              onChange={(e) => onChange(value.id, 'pricing', mascaraMoeda(e.target.value))}
                            />
                          </td>
                          <td data-label="Quantidade">
                            <input
                              type="number"
                              onChange={(e) => onChange(value.id, 'stock', e.target.value)}
                              value={value?.stock}
                            />
                          </td>
                          <td data-label="Unidade">
                            <select
                              value={value.type}
                              onChange={(e) => onChange(value.id, 'type', e.target.value)}
                            >
                              <option value="UN">UN</option>
                              <option value="LT">LT</option>
                              <option value="KG">KG</option>
                            </select>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                  {data?.length === 0 && <div className="admin-empty"><FiPackage size={25} /><strong>Nenhum item cadastrado</strong><span>Adicione o primeiro item ao estoque.</span></div>}
                  </div>
                </section>
              </>
            )}
        </main>
      </NavBar>
    </>
  )
}
